/**
 * SidebarEditContext.js — 사이드바 편집 모드 컨텍스트 (2026-04-27 신규)
 *
 * SidebarContent → MenuItem props drilling 회피.
 * MenuItem 이 useContext 로 직접 editMode/isSelected/onToggle 접근.
 *
 * Provider 미사용 시 default — editMode=false (평소 동작 유지, 회귀 zero).
 */
import { createContext, useContext } from 'react';

export const SidebarEditContext = createContext({
  editMode: false,
  selections: new Set(),
  toggle: () => {},
});

export function useSidebarEdit() {
  return useContext(SidebarEditContext);
}
